import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { getIn } from 'formik'

import InputField from '../InputField'

import useFieldErrorReset from '../Field/hook'

import useStyles from './styles'

function InlineField({ formik, name, id, className, autoComplete, symbol, type, onValueChange }) {
  const { values, errors, status, setStatus, touched, setFieldValue, setFieldError, setFieldTouched } = formik
  const value = getIn(values, name) || '' // use getIn to handle nested values correctly
  // server errors are saving in status due to native formik errors totally resets on Blur
  const serverError = status && status.serverErrors && status.serverErrors[name]
  const error = errors[name] || serverError
  const isTouched = touched[name]
  const showError = !!(isTouched && error)

  const classes = useStyles()

  const { resetError } = useFieldErrorReset({ error, errors, name, setFieldError, serverError, setStatus, status })

  return (
    // to avoid unnecessary re-renders formik sets only onBlur and field value is state manageable
    <div className={classnames('inlineField', className, classes.inlineField)}>
      <div className={classes.inputField}>
        <InputField
          id={id}
          name={name}
          formikValue={value}
          showError={showError}
          resetError={resetError}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          autoComplete={autoComplete ? autoComplete : 'on'}
          symbol={symbol}
          type={type}
          onValueChange={onValueChange}
        />
      </div>
    </div>
  )
}

export default InlineField

InlineField.propTypes = {
  id: PropTypes.string,
  autoComplete: PropTypes.string,
  name: PropTypes.string.isRequired,
  formik: PropTypes.object.isRequired,
  className: PropTypes.string,
  symbol: PropTypes.string,
  type: PropTypes.string
}
